import React, {useEffect, useRef, useState} from "react";
import {Button, ButtonGroup, FormControl, FormGroup} from "react-bootstrap";
import locale from "../../../locale";

const FILE_MAX_SIZE = 20971520;

const CPSettingImage = ({
    name,
    label,
    eventImageSrc,
    fileMaxSize = FILE_MAX_SIZE,
    availableTypes = null,
    hint = '',
    onChange,
}) => {
    const [imageSrc, setImageSrc] = useState('');
    const [error, setError] = useState('');
    const imageUploadRef = useRef(null);

    useEffect(() => {
        setImageSrc(eventImageSrc || '');
    }, [eventImageSrc]);

    function handleUploadImage(file) {
        if (file.size > fileMaxSize) {
            setError('settings.exesAllowableSize');

            return;
        }

        if (!!availableTypes && !availableTypes[file.type]) {
            setError('settings.wrongFileFormat');

            return;
        }

        setImageSrc(URL.createObjectURL(file));
        onChange({[name]: file});
        setError('');

    }

    function handleDeleteImage() {
        const allow = confirm(locale('settings.confirmImageRemove'));

        if (!allow) return;

        setImageSrc('');
        onChange({[name]: 'DELETE'});
    }

    function handleSelectImage() {
        imageUploadRef.current && imageUploadRef.current.click();
    }

    return (
        <FormGroup>
            <p>{label}:</p>
            <FormGroup>
                {
                    !!imageSrc &&
                    <img
                        src={imageSrc}
                        alt={label}
                        style={{
                            maxWidth: '320px',
                            maxHeight: '320px',
                        }}
                    />
                }
                {
                    (!!availableTypes && !imageSrc) &&
                    <p>
                        <i>
                            ({hint})
                        </i>
                    </p>
                }
                {
                    !!error &&
                    <p style={{color: 'red'}}>
                        <i>
                            {locale(`${error}`)}
                        </i>
                    </p>
                }
            </FormGroup>
            <ButtonGroup>
                <FormControl
                    type="file"
                    inputRef={(ref) => (imageUploadRef.current = ref)}
                    style={{display: 'none'}}
                    onChange={(e) => handleUploadImage(e.target.files[0])}
                />
                <Button onClick={handleSelectImage}>
                    {locale('email.upload')}
                </Button>
                {
                    !!imageSrc &&
                    <>
                        {' '}
                        <Button onClick={handleDeleteImage}>
                            {locale('email.delete')}
                        </Button>
                    </>
                }
            </ButtonGroup>
        </FormGroup>
    );
};

export default CPSettingImage;
